// icons
import { MdViewKanban } from "react-icons/md";

const kanbanBoard2 = {
    id: 'kanban-board-2-group',
    type: 'group',
    roles: [1],
    breadcrumbs: false,
    children: [
      {
        id: 'kanban-board-2',
        title: "Kanban board 2",
        type: 'item',
        breadcrumbs: false,
        icon: MdViewKanban,
        url: '/kanban-board-2'
      }
    ]
  };

export default kanbanBoard2;
